import { render, staticRenderFns } from "./TeacherCorrection2.vue?vue&type=template&id=27aef71a&scoped=true&"
import script from "./TeacherCorrection2.vue?vue&type=script&lang=js&"
export * from "./TeacherCorrection2.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCorrection2.vue?vue&type=style&index=0&id=27aef71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aef71a",
  null
  
)

export default component.exports